import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private mPreviousUrl: string;
  private currentUrl: string;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.mPreviousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }

  set previousUrl(value: string) {
    this.mPreviousUrl = value;
  }

  public inRootFromRoot() {
    return this.currentUrl === this.mPreviousUrl && this.currentUrl === '/';
  }

  /**
   * Gå bakåt från exempelvis en modal dialog.
   * Används exempelvis när man kan komma till en dialog från flera håll.
   *
   */
  public back(path: string[]): void {
    if (this.mPreviousUrl == null || this.currentUrl === this.mPreviousUrl) {
      this.router.navigate(path);
    } else {
      this.router.navigateByUrl(this.mPreviousUrl);
    }
  }
}
